import { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { useLmxStore } from './lmxStore';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Resuelve si LMX está disponible para este usuario. Lo decide SIEMPRE el
 * backend (flag de entorno + allowlist + preferencia del usuario). Mientras
 * no haya respuesta, `ready` queda en false y la app no muestra ninguna capa.
 */
export const useLmxAvailability = () => {
  const { getToken, isSignedIn } = useAuth();
  const ready = useLmxStore((s) => s.ready);
  const available = useLmxStore((s) => s.available);

  useEffect(() => {
    if (!isSignedIn) return undefined;
    let alive = true;
    (async () => {
      try {
        const token = await getToken();
        const res = await fetch(`${API}/api/lmx/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!alive) return;
        if (!res.ok) { useLmxStore.getState().setUnavailable(); return; }
        useLmxStore.getState().setAvailability(await res.json());
      } catch {
        if (alive) useLmxStore.getState().setUnavailable();
      }
    })();
    return () => { alive = false; };
  }, [getToken, isSignedIn]);

  return { ready: isSignedIn ? ready : true, available: isSignedIn ? available : false };
};

export default useLmxAvailability;
